import React, { Component } from "react";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import { Row, Col, Card, CardHeader, Container } from "reactstrap";
import VmProviderConfigForm from "../VmProviderConfigForm/VmProviderConfigForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import { updateVmProviderConfig } from "../../../actions/actionVmProvider";
import { handleSaveSuccess, handleSaveError } from '../actions'

const routes = [
    { name: "Home", path: "/userdashboard", isActive: false },
    { name: "Provider", path: "/provider", isActive: false },
    { name: "UpdateVmProvider", path: "/update_vm_provider", isActive: true },
];

class UpdateVmProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.submitApi = this.submitApi.bind(this);
        this.handleSaveError = handleSaveError.bind(this);
        this.handleSaveSuccess = handleSaveSuccess.bind(this);

    }

    componentDidMount(){
        this.props.getVmProviderConfigs();
    }

    async submitApi() {
        try {
            let userData = this.props.providerValues
            userData.vm_provider_config_id = this.props.match.params.id;
            await this.props.updateVmProviderConfig(userData)
            const provider = await this.handleSaveSuccess()
        } catch (e) {
            this.handleSaveError()
        }
    }

    render() {
        return (
            <div>
                <BreadCrumbCompo routes={routes} />
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update VM Provider Config </strong>
                                </CardHeader>
                                <VmProviderConfigForm
                                    onSubmit={this.submitApi}
                                    updateVmProviderConfig={this.props.updateVmProviderConfig}
                                    VmProviderConfigId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateVmProviderConfig.propTypes = {
    updateVmProviderConfig: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    vm_provider_configs: state.vm_provider.vm_provider_configs || [],
    saveVmProviderError: state.vm_provider.saveVmProviderError,
    saveVmProviderLoading: state.vm_provider.saveVmProviderLoading,
    savedVmProvider: state.vm_provider.savedVmProvider,
    providerValues: getFormValues('VmProviderForm')(state),
}),
    dispatch => ({
        updateVmProviderConfig: (data) => dispatch(updateVmProviderConfig(data))
    }))(UpdateVmProviderConfig);
